import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Navigate, useLocation } from 'react-router-dom'
import { hasSigned } from '../store/actions/user';
import { notification, Spin } from 'antd';

const PrivRoute = ({ component: Component, ...rest }) => {
    const location = useLocation();
    const isUserLoggedIn = useSelector((state) => state.user.isUserLoggedIn);
    const dispatch = useDispatch();


    // Local state for loading and authentication check
    const [loading, setLoading] = useState(true);
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    useEffect(() => {
        const checkAuth = async () => {
            if (isUserLoggedIn) {
                setIsAuthenticated(true);
                setLoading(false);
            } else {
                try {
                    const data = await dispatch(hasSigned());
                    if (data.success === 1) {
                        setIsAuthenticated(true);
                    } else {
                        notification.error({
                            message: "Adventencia",
                            description: "No se puede acceder a la pagina sin iniciar sesión",
                        });
                        setIsAuthenticated(false);
                    }
                } catch (error) {
                    console.error('Authentication check failed:', error);
                    notification.error({
                        message: "Adventencia",
                        description: "No se puede acceder a la pagina sin iniciar sesión",
                    });
                    setIsAuthenticated(false);
                } finally {
                    setLoading(false);
                }
            }
        };

        checkAuth();
    }, [isUserLoggedIn, dispatch]);

    if (loading) {
        // Show a loading spinner or placeholder while checking authentication
        return <Spin size="large" />;
    }

    if (isAuthenticated) {
        // Render the passed component if authenticated
        return <Component location={location} />;
    }

    // Redirect to login if not authenticated
    return <Navigate to="/login" state={{ from: location }} replace />;
};

export default PrivRoute